import { render, staticRenderFns } from "./PrasymasInformacija.vue?vue&type=template&id=6ab9634f&scoped=true&"
import script from "./PrasymasInformacija.vue?vue&type=script&lang=js&"
export * from "./PrasymasInformacija.vue?vue&type=script&lang=js&"
import style0 from "./PrasymasInformacija.vue?vue&type=style&index=0&id=6ab9634f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab9634f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
